import Logo from 'assets/campain/2024xmax/mainLogo.svg';

const HomeBannerBackground = require('assets/campain/2024xmax/homeBanner.png');
const ModalBackground = require('assets/campain/2024xmax/modalBanner.png');
const homeIcon = require('assets/campain/2024xmax/homeIcon.svg');
const modalIcon = require('assets/campain/2024xmax/modalIcon.svg');

const caFireHomeIcon = require('assets/campain/caFireWild/homeIcon.png');

//may
const HomeBannerBackgroundMay = require('assets/campain/mayCampain/homeBanner.svg');
const mayIcon = require('assets/campain/mayCampain/icon.svg');

const CampaignConfig = {
    'campaign-xmas-2024': {
        isCampaign: true,
        mainLogo: {
            logo: Logo,
        },
        upgradeTextInMainMenu: {
            text: '🎅🏻 Unlock your best Christmas Deal: Save up to [35%] on Kiwi Health Plans!',
        },
        homepageBanner: {
            wrap: {},
            leftPart: {
                paddingLeft: '184px',
            },
            icon: {
                url: homeIcon,
                width: '153px',
                height: '92px',
                left: '20px',
            },
            limitationBackground: 'linear-gradient(90deg, #F1CDA5 0%, #D09D64 100%)',
            limitationColor: '#04291E',
            titleColor: '#FFFFFF',
            descriptionColor: '#FFFFFF',
            background: `url(${HomeBannerBackground}) no-repeat center center`,
            JoinButton: {
                background: 'linear-gradient(90deg, #F1CDA5 0%, #D09D64 100%)',
                color: '#15191E',
                isLink: false,
                link: '',
            },
            joinedButton: {
                background: '#FFFFFF',
                color: '#15191E',
                text: 'Joined',
                isLink: false,
                link: '',
            },
            leaveButton: {
                background: '#F1CDA5',
                color: '#15191E',
                text: 'Leave Campaign',
            },
            showJoinedCount: false,
        },
        SelectionPopup: {
            icon: {
                url: modalIcon,
                width: '192px',
                height: '192px',
            },
            limitationBackground: 'linear-gradient(90deg, #E94C20 0%, #FDB160 109.71%)',
            selectionAreaBackground: `url(${ModalBackground}) no-repeat center center`,
            title: "",
            des: '',
            hideExcludedStates: false,
            limitationColor: '',
        },
        joinedSuccessMessage: {
            text: '🎉 Congratulations! You’ve successfully joined the Christmas campaign, offering {} off on all your initial visits.',
        },
        leaveCampaign: {
            title: 'Leave the campaign?',
            okText: 'Leave',
            cancelText: 'Cancel',
            footer: undefined,
            tipText: 'Are you sure you want to leave the Holiday Season Sale campaign? By opting out, your discounts will no longer be available to patients, and you may miss out on increased bookings during this limited-time event.',
        },
    },
    'la-wildfire-2025': {
        isCampaign: false,
        mainLogo: {
            logo: Logo,
        },
        homepageBanner: {
            wrap: {},
            leftPart: {
                paddingLeft: '184px',
            },
            icon: {
                url: caFireHomeIcon,
                width: '144px',
                height: '109px',
                left: '20px',
            },
            limitationBackground: 'linear-gradient(90deg, #2B9EF6 0%, #1684D8 100%)',
            limitationColor: '#FFFFFF',
            titleColor: '#141736',
            descriptionColor: '#374151',
            background: 'linear-gradient(277.91deg, #87C9FF 11.82%, #D9FCFF 58.22%, #C7EEFF 96.35%)',
            JoinButton: {
                background: '#FFFFFF',
                color: '#15191E',
                isLink: true,
                link: '/create-uni-profile?type=uniprofile&step=7&specialty=telehealth%20visit%20%26%20prescription%20refill',
            },
            joinedButton: {
                background: '#FFFFFF',
                color: '#15191E',
                text: 'Joined',
                isLink: false,
                link: '',
            },
            leaveButton: {
                background: '#FFFFFF',
                color: '#DC2626',
                text: 'Leave the program',
            },
            showJoinedCount: true,
        },
        SelectionPopup: {
            icon: {
                url: modalIcon,
                width: '192px',
                height: '192px',
            },
            limitationColor: '',
            limitationBackground: 'linear-gradient(90deg, #E94C20 0%, #FDB160 109.71%)',
            selectionAreaBackground: `url(${ModalBackground}) no-repeat center center`,
            title: '',
            des: '',
            hideExcludedStates: false,
        },
        joinedSuccessMessage: {
            text: '🎉 Congratulations! You’ve successfully joined the Christmas campaign, offering {} off on all your initial visits.',
        },
        leaveCampaign: {
            title: 'Leave the program?',
            okText: null,
            cancelText: null,
            footer: null,
            tipText: 'If you’d like to leave the LA wildfire telehealth program, please contact our support team at <a style="color: #006957" target="_blank" href="mailto:providersupport@helloklarity.com">providersupport@helloklarity.com</a>. By opting out, your $28 telehealth visit discount will no longer be available to patients, and your profile will be removed from the program’s search results. You may miss out on increased bookings and enhanced visibility.',
        },
    },
    'campaign-KMWM-2025': {
        isCampaign: true,
        mainLogo: {
            logo: Logo,
        },
        homepageBanner: {
            wrap: {},
            leftPart: {
                paddingLeft: '160px',
            },
            icon: {
                url: mayIcon,
                width: '150px',
                height: '150px',
                left: '0px',
            },
            limitationBackground: '#FFF0E5',
            limitationColor: '#996000',
            titleColor: '#141736',
            descriptionColor: '#374151',
            background: `url(${HomeBannerBackgroundMay}) no-repeat center center`,
            JoinButton: {
                background: '#FFFFFF',
                color: '#15191E',
                isLink: false,
                link: '/create-uni-profile?type=uniprofile&step=7&specialty=telehealth%20visit%20%26%20prescription%20refill',
            },
            joinedButton: {
                background: '#FFFFFF',
                color: '#15191E',
                text: 'Joined',
                isLink: false,
                link: '',
            },
            leaveButton: {
                background: '#FFFFFF',
                color: '#DC2626',
                text: 'Leave the campaign',
            },
            showJoinedCount: true,
        },
        SelectionPopup: {
            icon: {
                url: mayIcon,
                width: '160px',
                height: '160px',
            },
            limitationColor: '#FFFFFF',
            limitationBackground: 'linear-gradient(90deg, #E94C20 0%, #FDB160 109.71%)',
            selectionAreaBackground: `url(${ModalBackground}) no-repeat center center`,
            // title: 'Boost new patient bookings by up to 96% by joining our “Klarity Wellness Month” promotional campaign',
            // des: '<p>Take advantage of an unique opportunity to boost new patients by participating in our  “Klarity Wellness Month” promotional campaign in May.</p><p>Typically, when we ran this type of promotions in the past, we were able to boost bookings by 96% among providers who participated across all specialties. Opt in now to maximize your patient acquisitions in May!</p>',
            title: '',
            des: '',
            hideExcludedStates: true,
        },
        joinedSuccessMessage: {
            text: '🎉 Congratulations! You’ve successfully joined the Klarity Wellness Month, offering {} off on all your initial visits.',
        },
        leaveCampaign: {
            title: 'Leave the campaign?',
            okText: 'Leave',
            cancelText: null,
            footer: undefined,
            tipText: 'Are you sure you want to leave the Mental Health Wellness Month campaign? By opting out, your discounts will no longer be available to patients, and you may miss out on increased bookings during this limited-time event.',
        },
    },
};

export default CampaignConfig;
